import { HSpacer, IconButton, Text, VSpacer } from "@/components/DesignSystem";
import {
  Tier,
} from "@/pages/Admin/HierarchyOfRetailers/Retailer/RewardsPrograms/RewardsProgramModal";
import {
  RewardsTierSegment,
} from "@/pages/Admin/HierarchyOfRetailers/Retailer/RewardsPrograms/RewardsTierSegment";
import { ApiCategory } from "@api/interfaces";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Stack, useTheme } from "@mui/material";
import { styled } from '@mui/material/styles';
import { formatCurrency } from "@shared/utilities";
import i18next from 'i18next';
import React, { useState } from "react";

const RewardsTierAccordion = styled(Accordion)(() => {
  const theme = useTheme();
  return {
    '&:before': {
      display: 'none',
    },
    '&.MuiAccordion-root': {
      backgroundColor: theme.palette.background.paper,
      borderRadius: '8px',
      boxShadow: 'none',
    },
    '.MuiAccordionDetails-root': {
      backgroundColor: theme.palette.background.paper,
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
    },
    '.MuiAccordionSummary-root': {
      backgroundColor: theme.palette.background.paper,
      borderRadius: '8px',
      '&.Mui-expanded': {
        backgroundColor: theme.palette.background.paper,
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
      },
    },

  };
});

interface RewardsTierProps {
  categories: ApiCategory[],
  categoryExclusions: {
    categoryIdsExcludedFromSegmentSpend?: string[],
    categoryIdsExcludedFromTierSpend?: string[],
  },
  editing?: boolean,
  rank: number,
  tier: Tier,
}

export const RewardsTier = ({
  categories,
  categoryExclusions,
  editing = false,
  rank,
  tier,
}: RewardsTierProps) => {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();

  return (
    <RewardsTierAccordion disableGutters expanded={expanded}>
      <AccordionSummary onClick={() => setExpanded(!expanded)}>
        <Stack alignItems="center" direction="row" justifyContent="space-between" width={"100%"}>
          <Stack direction="row">
            <HSpacer size="3"/>
            <Text category="body-large">
              {rank}
            </Text>
            <HSpacer size="5"/>
            <Text category="body-large">
              {tier.name}
            </Text>
          </Stack>
          <Stack direction="row">
            <Stack width="160px">
              <Text category="body-small" sx={{ color: theme.palette.text.secondary }}>
                Min total spend
              </Text>
              <VSpacer size="1" />
              <Text category="body-large">
                {formatCurrency(tier.minimumDollars, i18next)}
              </Text>
            </Stack>
            <Stack width="160px">
              <Text category="body-small" sx={{ color: theme.palette.text.secondary }}>
                Min categories
              </Text>
              <VSpacer size="1" />
              <Text category="body-large">
                {tier.minimumSegments}
              </Text>
            </Stack>
            {editing && (
              <>
                <IconButton
                  color="primary"
                  testID={`${tier.name}-edit-button`}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  color="primary"
                  testID={`${tier.name}-delete-button`}
                >
                  <DeleteOutlined />
                </IconButton>
              </>
            )}
            <IconButton color="inherit" testID={`${tier.name}-expand-button`}>
              {expanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
            </IconButton>
          </Stack>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack sx={{ paddingLeft: "35px" }}>
          {tier.segments.map((segment) => (
            <RewardsTierSegment
              categories={categories}
              categoryExclusions={categoryExclusions}
              key={segment.categoryId}
              segment={segment}
            />
          ))}
        </Stack>
      </AccordionDetails>
    </RewardsTierAccordion>
  );
};
